import { Endpoints, fetch, normalizeKeys } from '../api'

export const fetchFilters = async sourceId => {
  const uri = `${Endpoints.Wizard}/${sourceId}/Filters`
  const response = await fetch(uri)
  return normalizeKeys(response.data || {})
}

export const fetchReportFilters = async reportId => {
  const uri = `${Endpoints.Report}/${reportId}/Filters`
  const response = await fetch(uri)
  return normalizeKeys(response.data)
}

export const fetchLiveReportFilters = async ({ productId, planId, snapshotId }) => {
  //set default to 12 for now
  if (planId === undefined || planId == null)
    planId = 12
  const base = snapshotId
    ? `${Endpoints.LiveReport}/${productId}/${planId}/snapshot/${snapshotId}`
    : `${Endpoints.LiveReport}/${productId}/${planId}`
  const uri = `${base}/Filters`
  const response = await fetch(uri)
  return normalizeKeys(response.data)
}
